module.exports = __webpack_public_path__ + "images/017c12cc0752dd4f6a688e1c75b8c3ba.svg";